import React, { forwardRef, useState } from 'react';
import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ComponentProps {
  label?: string;
  onClick?(): void;
  className?: string;
  // Accept legacy props but ignore for styling
  variant?: string;
  size?: string;
  // Support data attributes for CTA routing
  'data-cta'?: string;
  [key: string]: any; // Allow other data attributes to pass through
}

export const Component = forwardRef<HTMLButtonElement, ComponentProps>(
  ({ label = "Generate", onClick, className, variant = "primary", size = "default", ...props }, ref) => {
    const [isClicked, setIsClicked] = useState(false);

    const handleClick = () => {
      setIsClicked(true);
      setTimeout(() => setIsClicked(false), 200);
      onClick?.();
    };

    return (
      <button
        ref={ref}
        type="button"
        aria-label={label}
        className={cn(
          "glow-btn", 
          variant === "secondary" && "glow-btn--secondary",
          variant === "green" && "glow-btn--green",
          variant === "outline" && "glow-btn--outline",
          variant === "blue" && "glow-btn--blue",
          variant === "theme" && "glow-btn--theme",
          size === "sm" && "glow-btn--sm",
          size === "hero" && "glow-btn--hero", 
          size === "lg" && "glow-btn--lg",
          className
        )}
        onClick={handleClick}
        data-state={isClicked ? "clicked" : undefined}
        {...props}
      >
        <span className="flex items-center justify-center gap-1.5">
          {label}
          <Sparkles size={16} className="ml-0.5" />
        </span>
      </button>
    );
  }
);

Component.displayName = "Component";

// Backwards compatibility with previous imports
export const GlowButton = Component;
